module.exports = __webpack_public_path__ + "static/media/sofar-ocean-home.8eed4a17.png";